module.exports = __webpack_public_path__ + "static/media/jateng.af8ad8f1.png";